<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('campaign-partner')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Campaign Partner</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="partner_data.title"
        >
        </base-input>

        <base-input
          alternative
          class="mb-3"
          name="Social Link"
          :rules="{ required: true }"
          placeholder="Social Link"
          v-model="partner_data.link"
        >
        </base-input>

        <quill-editor
          v-model="partner_data.description"
          :options="editorOption"
          class="quill-h200px my-2"
        />

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 180 × 90px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <div v-if="image">
          <p class="mb-2 text-danger">Image Preview</p>

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
          <img v-if="image" :src="image" ref="cover" />
        </div>

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            :src="$imageURL + '/' + partner_data.image"
            alt=""
          />
          <base-button
            v-if="partner_data.image"
            type="danger"
            class="px-8"
            @click="handleRemove"
          >
            Remove image
          </base-button>
        </div>

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      description: "",
      selected: [],
      image: "",
      imageErr: false,
      coverImage: "",
      filter1: [],
      filter2: [],
      filter3: [],
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      pageData: {},
      partner_data: {},
    };
  },
  computed: {
    ...mapState("campaignPageBanner", {
      selectedPartner: "selectedPartner",
    }),
  },
  watch: {
    pageData(val) {
      this.partner_data = { ...val };
    },
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;

      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let loader = this.$loading();
      let FormData = require("form-data");
      let data = new FormData();
      data.append("_id", this.partner_data._id);
      data.append("title", this.partner_data.title);
      data.append("description", this.partner_data.description);
      data.append("link", this.partner_data.link);
      data.append("image", this.coverImage);

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      try {
        const editData = await this.$store.dispatch(
          "campaignPageBanner/update_partner",
          data
        );
        // if (editData.code == 200) {
        this.$router.push({ name: "campaign-partner" });
        this.$swal.fire({
          text: "Partner Edited Successfully",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async dataLoad() {
      this.pageData = this.selectedPartner;
    },
    handleRemove() {
      this.image = null;
      this.partner_data.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.dataLoad();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
